import ThCustom from "@ui/tableCustom/view/ui/thCustom/ThCustom";
import {Stack, Tooltip, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {IColumnItem} from "@ui/tableCustom/types/columns";
import {
    IExportMutateContext,
    IExportParamsContext
} from "@containers/export/containers/buildData/hooks/types/exportParams";
import {mapperColumnCbType} from "@ui/tableCustom/types/table";
import TableHeadColumnBaseFeatures from "@ui/tableCustom/head/baseFeatures/TableHeadColumnBaseFeatures";


interface IProps<T> {
    exportParams: IExportParamsContext<T>,
    exportMutate: IExportMutateContext<T>,
    mapperColumnCb?: mapperColumnCbType<T>,
    order: keyof T | false,
    setOrder: (order: keyof T) => void
    direction: string,
    setDirection: (order: string) => void,
    column: IColumnItem<T>,
    globalIndex?:number,

}


function TableCustomHeadItem<T>({
                                    exportMutate,
                                    exportParams,
                                    column,

                                    direction, setDirection,
                                    order, setOrder,
                                }: IProps<T>) {
    const {title, shortTitle} = column;
    const {t} = useTranslation()

    const titleUi = (
        <Typography
            sx={{fontWeight: 700, whiteSpace: shortTitle ? 'nowrap' : undefined}}
            variant={'body2'}>
            {shortTitle ? t(shortTitle) : title}
        </Typography>
    )

    return (
        <ThCustom
            size={'medium'}
            sx={column.uiStyles}
            rowSpan={column.rowSpan}
            colSpan={column.colSpan}
        >
            <Stack
                gap={1}
                direction={'row'}
                alignItems={'center'}
                justifyContent={'flex-start'}
                className={'rootContent'}
            >
                {shortTitle ? <Tooltip title={title}>
                    {titleUi}
                </Tooltip> : titleUi}

                <TableHeadColumnBaseFeatures
                    <T>
                    exportMutate={exportMutate}
                    exportParams={exportParams}
                    column={column}
                    direction={direction}
                    setDirection={setDirection}
                    order={order}
                    setOrder={setOrder}
                />
            </Stack>
        </ThCustom>
    );
}

export default TableCustomHeadItem;